import { Center, HStack, Image, Link, Text, Tooltip } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Link as ReactDOMLink, useLocation } from "react-router-dom";
import { useAccount } from "wagmi";

import analyticsInstance from "../config/analytics";

const navLinks = ["", "stats", "faq", "wallet"];

function applyCurrentLinkStyles(navLinkIdx, currentLink) {
  return currentLink === navLinks[navLinkIdx]
    ? { color: "goldenrod", textDecoration: "underline", textUnderlineOffset: "0.5em" }
    : {};
}

function Header() {
  const { isConnected, address } = useAccount();
  let location = useLocation();

  const [selectedNavLink, setSelectedNavLink] = useState(navLinks[0]);

  useEffect(() => {
    let parts = location.pathname.split("/");
    setSelectedNavLink(parts[1]);
  }, [location.pathname]);

  return (
    <Center
      as="header"
      position="sticky"
      top="0"
      w="full"
      h={{ md: "4em" }}
      px="4"
      zIndex="50"
      bg="#28282A"
      textColor="white"
      textTransform="uppercase"
      fontWeight="bold"
      display={{ base: "grid", md: "flex" }}
    >
      <HStack px="1em" pt={{ base: "1em", md: "0" }} pb={{ base: "0.25em", md: "0" }}>
        <Image src="./logo192.png" boxSize="3em" alt="BTFDCA Logo" mr="0.5em" />
        <Text fontSize="2xl">#BTFDCA</Text>
      </HStack>

      <Link
        as={ReactDOMLink}
        key={navLinks[0]}
        to="/"
        px="1em"
        py={{ base: "0.25em", md: "0" }}
        _hover={{ textDecoration: "none" }}
        style={applyCurrentLinkStyles(0, selectedNavLink)}
        onClick={() => {
          analyticsInstance.track("HeaderMainClicked");
        }}
      >
        🏠&nbsp;Main
      </Link>

      <Link
        as={ReactDOMLink}
        key={navLinks[2]}
        to="/faq"
        px="1em"
        py={{ base: "0.25em", md: "0" }}
        _hover={{ textDecoration: "none" }}
        style={applyCurrentLinkStyles(2, selectedNavLink)}
        onClick={() => {
          analyticsInstance.track("HeaderFAQClicked");
        }}
      >
        ❓&nbsp;FAQ
      </Link>

      {/*
      <Text
        as={ReactDOMLink}
        key={navLinks[1]}
        to="/stats"
        px="1em"
        py={{ base: "0.25em", md: "0" }}
        _hover={{textDecoration: "none"}}
        style={applyCurrentLinkStyles(1, selectedNavLink)}
        onClick={() => {
          analyticsInstance.track("HeaderAnalyticsClicked");
        }}
      >
        🧮&nbsp;Analytics (SOON)
      </Text>
      */}

      {isConnected && address && (
        <>
          <Link
            as={ReactDOMLink}
            to="/wallet"
            px="1em"
            py={{ base: "0.25em", md: "0" }}
            key={navLinks[3]}
            _hover={{ textDecoration: "none" }}
            style={applyCurrentLinkStyles(3, selectedNavLink)}
            onClick={() => {
              analyticsInstance.track("HeaderWalletClicked");
            }}
          >
            👛&nbsp;Wallet
          </Link>

          <Tooltip bg="red.500" color="white" label={address} fontSize="sm" placement="auto" closeDelay={100}>
            <Text
              fontSize={{ base: "md", md: "xs" }}
              fontWeight="light"
              px={{ base: "1em", md: "0" }}
              pt={{ base: "0.25em", md: "0" }}
              pb={{ base: "1em", md: "0" }}
            >
              📒&nbsp;{address.substring(0, 7) + "..." + address.substring(address.length - 5)}
            </Text>
          </Tooltip>
        </>
      )}
    </Center>
  );
}

export default Header;
